module.exports = __webpack_public_path__ + "1532e13434700c0594b9317a6200b8a5.png";